import * as React from 'react';
import { FormGroup } from '@mui/material';
import CheckboxLabel from '@components/CheckboxLabel';
import allergansData from './AllergansData';
import _ from 'lodash';

export default function({ allergens, handleChangeInput }) {
  const allergensLower = allergens.map(i => i.toLowerCase());

  return (
    <FormGroup row sx={{ px: 1.875 }}>
      {allergansData.map((allergen, id) => (
        <CheckboxLabel
          key={`${allergen}+${id}`}
          name="allergens"
          label={allergen}
          checked={_.includes(allergensLower, allergen.toLocaleLowerCase())}
          onChange={handleChangeInput}
        />
      ))}
    </FormGroup>
  );
}
